import React from 'react';
import { Button, Col, Icon, Input, Popconfirm, Radio, Row, Table, Tooltip } from 'antd';
import { Resource } from 'rt-sd-common/sgiFactory/Resource';
import { copyArr, Format, uuid, funStrCheck, getType } from 'rt-sd-common/sgiCommon/sgiCommon';
import { sgiLogger } from 'rt-sd-common/sgiCommon/sgiLogger';
import { StandardCode } from 'rt-sd-common/sgiFactory/StandardCode';
import { PrmFactory } from 'rt-sd-common/sgiFactory/PrmFactory';
import { addCtnCommonAttribute } from "./SgiCtnComm";
import { SgiEventHandler } from './SgiEventHandler';
import SgiTableEditorCell from './SgiTableEditorCell';
import { sgiTableBaseFun } from './SgiTableBaseFun';
import { Resizable } from 'react-resizable';
import SgiTableCommon from './SgiTableCommon';
import { getConstByKey } from './sgiBaseComp/SgiCommon';
// import '../node_modules/react-resizable/css/styles.css';

const RadioGroup = Radio.Group;

const ResizeableTitle = (props) => {
    const { onResize, width, isLast, ...restProps } = props;

    if (isLast) {
        return <th {...restProps} />;
    }

    return (
        <Resizable width={parseInt(width)} height={0} onResize={onResize}>
            <th {...restProps} />
        </Resizable>
    );
};
const components = {
    header: { cell: ResizeableTitle },
};

class SgiTable extends React.Component {

    static defaultProps = {
        // type: 'N',
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号

    constructor(props) {
        super(props);
        this.state = {
            showPageFlg: true,//是否显示翻页信息
            pagination: {},//分页信息
            batchInfo: {},//分批查询信息
            size: 'default',
            expandedRowRender: [], //展开列
            footer: {},
            rowSelection: null, //选择属性
            columns: [], //列信息
            expandedColumns: [], //列信息
            tableProps: { style: {} }, //表格属性
            dataSource: [], //显示数据==>原始数据
            store: [], //表格的显示数据(原始数据筛选后)
            insName: '',//绑定实例名
            loading: false, //刷新属性 //是否加载中
            // selectedRowKeys: [] //选择的列信息 //放入到了rowSelection中
            functions: {},
            selectedRows: [], //已选择/勾选的行对象数组
            selFlg: false,
            selValues: {},//筛选对象
            contain: true,//筛选选择(包含/不包含)，默认包含
            cstmClmnFlg: false,//自定义表格列描述
            resizable: false,//列头可伸缩
        };
    }

    /**
     * 根据描述创建表格
     * @param {父组件} parentModule
     * @param {组件描述} moduleDesc
     * @param {绑定实例ID} bdInst
     * @param {当前工作区} ws
     * @param {make类型} type
     */
    table_mk(parentModule, moduleDesc, bdInst, objFct, type) {

        //获取需要展示的数据信息
        var moduleDesc = this.props.moduleDesc;
        if (!moduleDesc) {
            return;
        }

        //取得绑定列描述信息
        var ClmDes = this.getClmDes(moduleDesc, ClmDes);
        //绑定数据，创建表格store 搜索条、翻页控件需要使用该信息，所以先创建
        var tableStore = this.getTBData(moduleDesc, objFct);
        this.state.dataSource = tableStore;
        this.state.insName = getConstByKey(this, moduleDesc.insName);//绑定实例名
        //创建表头
        var clms = this.crtClmHead(moduleDesc, ClmDes, objFct, type);
        this.state.columns = clms ? clms : [];

        //添加表格列,拖拽页面自定义的表格列
        this.crtClmHeadDnd(moduleDesc, moduleDesc.dnd_columns, this.state.columns, this.state.expandedColumns, objFct, type);

        //分页信息
        this.crtPgeBbar(moduleDesc, tableStore, objFct);
        //转换公共属性
        addCtnCommonAttribute(this, moduleDesc, this.state.tableProps);
        //创建表格属性
        this.AddTBAttribute(moduleDesc, this.state.tableProps, type);
        //添加表格的选择模式
        this.crtTblSltModel(moduleDesc);
        //绑定事件
        this.bindEvent(moduleDesc, this.state.tableProps, this.state.rowSelection, this.state.functions, type);
    }

    /**
     * 表格基本属性
     * @param {*} moduleDesc
     * @param {*} tableColumn
     */
    AddTBAttribute(moduleDesc, tableProps, type) {

        // tableProps.scroll = {};
        // var ctlW = moduleDesc.ctlW; //form宽度
        // if (ctlW) tableProps.scroll.x = ctlW;
        // var ctlH = moduleDesc.ctlH; //form高度
        // if (ctlH) tableProps.scroll.y = ctlH;
        if (moduleDesc.isHeaders) tableProps.showHeader = !moduleDesc.isHeaders; //隐藏列头
        if (moduleDesc.isTbSpt) tableProps.bordered = moduleDesc.isTbSpt; //列线
        // if (moduleDesc.te) tableProps.title = tableProps.te;//公共转换中已从资源获取//Resource.getTRByPrm(moduleDesc).te; //表头
        // if (moduleDesc.isTtl) tableProps.showHeader = moduleDesc.isTtl; //是否显示表头

        this.state.selFlg = !!moduleDesc.isSel; //是否筛选
        this.state.showPageFlg = (moduleDesc.isPage === false) ? false : true; //是否显示翻页器,默认显示

        // 表格大小
        tableProps.size = moduleDesc.size || "small";

        // 初始loading
        this.state.loading = (type === "dnd") ? false : (!!moduleDesc.loading);

        // 横向滚动
        if (!tableProps.scroll) tableProps.scroll = {};
        if (moduleDesc.scrollX) tableProps.scroll.x = moduleDesc.scrollX;
        else delete tableProps.scroll;

        // 列可伸缩
        this.state.resizable = !!moduleDesc.resizable;

        // 默认全部展开
        tableProps.defaultExpandAllRows = moduleDesc.defaultExpandAllRows;
        // 指定树形结构的列名
        tableProps.childrenColumnName = moduleDesc.childrenColumnName || "children";
    }

    /**
     * 创建表格 列头信息
     * @param {*} moduleDesc
     * @param {*} ClmDes
     * @param {*} objFct
     * @param {*} type
     */
    crtClmHead(moduleDesc, ClmDes, objFct, type) {
        //wangz追加 如果表格配置信息错误  自定义表头
        if (!ClmDes) {
            return;
        }
        var tableColumns = ClmDes.cldSet;
        var alwEdit = moduleDesc.isEd;
        var clm = this.crtTblClm(alwEdit, tableColumns, getConstByKey(this, moduleDesc.insName), objFct, type);
        return clm;
    }

    /**
     * 获取表格 列头信息，如果列头是根树，则迭代遍历
     * 表格头数据
     */
    crtTblClm(alwEdit, tblClms, bdData, objFct, type) {
        var clms = [];
        tool.sgiLogger.log(tblClms);
        for (var i in tblClms) {
            var clm = {};
            var clmDes = tblClms[i];
            var cluW = clmDes.cluW;
            if (!cluW) {
                cluW = undefined; //默认大小
            }
            var text = Resource.getTRByPrm(clmDes).te;//clmDes.te;
            clm.title = text;
            clm.width = cluW; //设置列宽
            if (clmDes.isSt) {//该列是否可排序
                clm.sorter = (a, b) => {
                    return a.name.length - b.name.length;
                }
            }
            // clm.align = Ep.Utl.getClmAlg(clmDes.teAl); //设置列标题和数据的对其方式 0 :left 1:center 2;right
            // clm.hidden = clmDes.isHdn; //对应Ext是“是否隐藏”属性
            // clm.hideable = clmDes.HdAbl; //对应Ext是“是否隐藏”属性
            // clm.menuDisabled = clmDes.isCluMu; //是否显示列头菜单
            // clm.draggable = clmDes.isDgClu; //设置列头是否可以拖动，默认为true
            // clm.locked = clmDes.isLkClu; //表格是否可以锁定
            // clm.lockable = clmDes.isUnlkClu; //是否可通过列menu进行解锁
            // clm.groupable = clmDes.isGp; //设置在使用groupping分组特性的情况下是否禁止该列在标题菜单中等的分组功能
            // clm.flex = clmDes.cluSca; //列宽的比例
            // if (clmDes.fmter) {
            //     clm.formatter = clmDes.fmter;
            // }
            // //合计种类 summaryType sum
            // clm.summaryType = clmDes.smayType;
            // //合计函数 summaryRenderer
            // if (clmDes.smayFun) {
            //     var getTextStyle = new Function("value", "summaryData", "dataIndex", clmDes.smayFun);
            //     clm.summaryRenderer = getTextStyle;
            // }
            // clm.disIndex = clmDes.isdisIndex;//显示列  20170522增加-wangj
            // Ep.Utl.crtTblClmFmt(clm, clmDes, bdData, objFct, ws, type); //表格数据格式化展示
            // var isEditor = clmDes.isEd; //表格列是否可编辑
            // if (isEditor) {
            //     var ctlDes = clmDes.cldSet;
            //     if (ctlDes) {
            //         clm.editor = this.crtTblClmEditor(clmDes, bdData, objFct, ws, type);
            //     }

            // }
            // var childs = clmDes.cldSet;
            // if (clmDes.isGp && !this.isEmpty(childs) && childs.length > 0 && childs[0].desId === "EP_EO_TV_Node") {
            //     clm.columns = this.crtTblClm(alwEdit, childs, bdData, objFct, ws, type, true);
            // } else {
            //     clm.dataIndex = clmDes.c; //设置列与数据集中数据的对应关系值为数据模型中的字段名称
            // }
            clm.dataIndex = clmDes.c;
            clm.align = clmDes.align;
            clms[i] = clm;
        }
        return clms;
    }

    /**
     * 获取表格列描述信息
     * @param {描述信息} moduleDesc
     */
    getClmDes(moduleDesc) {
        //是否绑定表头了，绑定了继续
        var guid = moduleDesc.cluDes;
        if (!guid) {
            return;
        }
        //取得表头guid
        var ClmDes = PrmFactory.getPrm(guid);
        return ClmDes;
    }

    //渲染并返回一个虚拟DOM
    render = function () {

        const { parentModule, moduleDesc, bdInst, objFct, type } = this.props;

        if (!this.loaded) {
            //组装属性 初始化属性到this.state
            this.table_mk(parentModule, moduleDesc, bdInst, objFct, type);
            this.loaded = true;
        }

        if (this.state.selFlg) this.onSel();//筛选
        else this.state.store = this.state.dataSource;//不筛选

        const { cstmClmnFlg, cstmClmn, store, resizable } = this.state;

        // 自定义列描述
        if (cstmClmnFlg) {
            try {
                this.state.columns = cstmClmn(this, objFct, store) || [];
            } catch (error) {
                tool.sgiLogger.log(error);
            }
        }

        let columns = this.state.columns;
        // 可伸缩列
        if (resizable) {
            this.state.tableProps.components = components;
            columns = this.state.columns.map((col, index, arr) => ({
                ...col,
                onHeaderCell: column => ({
                    width: column.width,
                    onResize: this.handleResize(index),
                    isLast: (index === arr.length - 1)
                }),
            }));
        }

        return (
            <div>
                <div style={{ margin: 5, width: "70%", minWidth: 400, maxWidth: 800, display: (this.state.selFlg ? undefined : "none") }} >
                    {/* <Col span={10} style={{ margin: "0px 5px 0px 5px" }}> */}
                    <Row >
                        <Col span={14}>
                            <Input addonBefore="筛选条件" value={this.state.selValues.mat} onChange={this.selOnChange.bind(this, 'mat')} />
                        </Col>
                        <Col span={10}>
                            <RadioGroup style={{ marginTop: 3, marginLeft: 10 }} value={this.state.contain} onChange={this.containOnChange.bind(this)}>
                                <Radio value={true} style={{ marginRight: 0 }}>包含</Radio>
                                <Radio value={false}>排除</Radio>
                            </RadioGroup>
                        </Col>
                    </Row>
                    {/* </Col> */}
                </div>
                <Table className="sgiTable" {...this.state.tableProps}
                    rowKey={"_key"}
                    loading={this.state.loading}
                    pagination={this.state.showPageFlg ? this.state.pagination : false}
                    rowSelection={this.state.rowSelection}
                    columns={columns}
                    dataSource={this.state.store}
                    onChange={this.tableOnChange.bind(this)}
                    expandedRowRender={this.state.expandedColumns.length > 0 ? this.expandedRowRender.bind(this) : undefined} />
            </div>
        );
    }
}
//给类添加公共方法
Object.assign(SgiTable.prototype, sgiTableBaseFun);
Object.assign(SgiTable.prototype, SgiTableCommon);
export { SgiTable };
export default SgiTable;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiTable.js